import ReportSelect from "./ReportSelect";

function OnlineButNotRegistered(props) {
  return <ReportSelect type={"communicating-but-not-registered"} />;
}

export default OnlineButNotRegistered;
